module.exports = __webpack_public_path__ + "img/index_bg.387d20e0.png";